import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MotivizerPage } from './motivizer';
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [MotivizerPage],
  imports: [IonicPageModule.forChild(MotivizerPage), FormsModule],
})
export class MotivizerPageModule {}



// WEBPACK FOOTER //
// ./src/modules/motivizer/pages/motivizer.module.ts